module.exports = __webpack_public_path__ + "img/avatar7.2c6808d7.png";